export const loginConstants = {
	LoginGetDetailRequest: "LOGIN_GET_DETAIL_STARTED",
	LoginGetDetailSuccess: "LOGIN_GET_DETAIL_COMPLETED",
	LoginGetDetailFailure: "LOGIN_GET_DETAIL_FAILED",

	LogoutGetDetailRequest: "LOGOUT_GET_DETAIL_STARTED",
	LogoutGetDetailSuccess: "LOGOUT_GET_DETAIL_COMPLETED",
	LogoutGetDetailFailure: "LOGOUT_GET_DETAIL_FAILED",

	CheckLoggedUserRequest: "FETCH_CHECKLOGGEDUSER_STARTED",
	CheckLoggedUserSuccess: "FETCH_CHECKLOGGEDUSER_COMPLETED",
	CheckLoggedUserFailure: "FETCH_CHECKLOGGEDUSER_FAILED",

	ForgotPasswordRequest: "FORGOT_PASSWORDREQUEST_STARTED",
	ForgotPasswordSuccess: "FORGOT_PASSWORDREQUEST_COMPLETED",
	ForgotPasswordFailure: "FORGOT_PASSWORDREQUEST_FAILED",

	ForgotPasswordCheckTokenRequest: "FORGOT_PASSWORD_CHECKTOKEN_STARTED",
	ForgotPasswordCheckTokenSuccess: "FORGOT_PASSWORD_CHECKTOKEN_COMPLETED",
	ForgotPasswordCheckTokenFailure: "FORGOT_PASSWORD_CHECKTOKEN_FAILED",

	ForgotPasswordChangeRequest: "FORGOT_PASSWORD_CHANGE_STARTED",
	ForgotPasswordChangeSuccess: "FORGOT_PASSWORD_CHANGE_COMPLETED",
	ForgotPasswordChangeFailure: "FORGOT_PASSWORD_CHANGE_FAILED",

	FrontAppCheckTokenRequest: "FRONTAPP_CHECK_TOKEN_STARTED",
	FrontAppCheckTokenSuccess: "FRONTAPP_CHECK_TOKEN_COMPLETED",
	FrontAppCheckTokenFailure: "FRONTAPP_CHECK_TOKEN_FAILED",

	GetUserByRefreshTokenRequest	: "GET_USER_BY_REFRESH_TOKEN_STARTED",
	GetUserByRefreshTokenSuccess	: "GET_USER_BY_REFRESH_TOKEN_COMPLETED",
	GetUserByRefreshTokenFailure	: "GET_USER_BY_REFRESH_TOKEN_FAILED",
}